
import { defaultMarkerFilter } from '../libs/getDefaultOptions'
import _ from 'lodash'

export function isDefaultFilter(f) {
    return _.isEqual(f, defaultMarkerFilter)
}
